// Límites del buscador del súper online (PR 5). MÓDULO PURO, sin imports de servidor: los
// comparten el buscador (`search.ts`, servidor) y la caja de búsqueda (cliente), para que lo que
// la caja deja de pedir y lo que el servidor rechaza no se separen.

/** Menos letras que esto: ni autocompletado ni página de resultados. */
export const SEARCH_MIN_CHARS = 2
/** La consulta se corta en este largo. */
export const SEARCH_MAX_CHARS = 64
/** Artículos por página de resultados (los mismos que un pasillo). */
export const SEARCH_PAGE_SIZE = 48
/** Sugerencias del autocompletado. */
export const SUGGEST_LIMIT = 8

/**
 * La consulta lista para buscar: sin espacios en los bordes y cortada en `SEARCH_MAX_CHARS`
 * PUNTOS DE CÓDIGO (no unidades UTF-16): un `.slice` partía un emoji en la posición del corte
 * y dejaba medio par sustituto, que `encodeURIComponent` no acepta.
 */
export function clampSearchQuery(raw: string): string {
  return Array.from(raw.trim()).slice(0, SEARCH_MAX_CHARS).join("").trim()
}
